import angular from 'angular';
import { goTablistKeyboardNavigation } from './go-tablist-keyboard-navigation.directive';

export const goTablistKeyboardNavigationModule = angular.module('go-tablist-keyboard-navigation', [])
	.directive('goTablistKeyboardNavigation', goTablistKeyboardNavigation)
	.name;
